import { createContext } from 'react';
import { FormInput } from './FormInputs';
import { FormFieldSetStatus, FormFieldStatus } from './FormFieldStatus';

export type FormField = {
  status: FormFieldStatus;
  setStatus: FormFieldSetStatus;
};

export type ContextValue = {
  inputs: Map<string, FormInput[]>;
  fields: Map<string, FormField>;
};

export const FormContext = createContext<ContextValue>({
  inputs: new Map(),
  fields: new Map(),
});
